import axios from 'axios';
import { installTokenRefresh } from './tokenRefresh';

const API = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api`
});

API.interceptors.request.use((req) => {
    const token = localStorage.getItem('token');
    if (token) req.headers.Authorization = `Bearer ${token}`;
    return req;
});

// an expired login token is swapped for a fresh one automatically, for this instance and for plain axios calls across the site
installTokenRefresh(API);
installTokenRefresh(axios);

export const registerUser = (data) => API.post('/auth/register', data);
export const loginUser = (data) => API.post('/auth/login', data);
export const sendLoginOtp = (data) => API.post('/auth/login-otp/send', data);
export const verifyLoginOtp = (data) => API.post('/auth/login-otp/verify', data);
export const getLinkedRoles = () => API.get('/auth/linked-roles');
export const switchAccountRole = (role) => API.post('/auth/switch-role', { role });
export const sendRegisterOtp = (data) => API.post('/auth/send-otp', data);
export const verifyRegisterOtp = (data) => API.post('/auth/verify-otp', data);
export const saveRegistrationDraft = (data) => API.post('/auth/registration-draft', data);
export const getMe = () => API.get('/auth/me');
export const sendEmailVerifyOtp = (data) => API.post('/auth/verify-email/send-otp', data);
export const verifyEmailVerifyOtp = (data) => API.post('/auth/verify-email/verify-otp', data);
export const sendMobileVerifyOtp = (data) => API.post('/auth/verify-mobile/send-otp', data);
export const verifyMobileVerifyOtp = (data) => API.post('/auth/verify-mobile/verify-otp', data);
export const forgotPasswordSendOtp = (data) => API.post('/auth/forgot-password/send-otp', data);
export const forgotPasswordReset = (data) => API.post('/auth/forgot-password/reset', data);
export const getProfiles = (filters) => API.get('/profiles', { params: filters });
export const getProfileById = (id) => API.get(`/profiles/${id}`);
export const createProfile = (data) => API.post('/profiles', data);
export const updateProfile = (data) => API.put('/profiles/my', data);
export const getServices = (filters) => API.get('/services', { params: filters });
export const createBooking = (data) => API.post('/bookings', data);
export const getMyBookings = () => API.get('/bookings/my');
export const suggestOption = (data) => API.post('/options/suggest', data);

export default API;
